export default __webpack_public_path__ + "static/media/nexticon.98f18e6e.svg";